var _desc, _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuality(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 5.2.4")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "cff9f87c-a1bf-486b-8317-ec908d6ea44f"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 1,
      visibility: "hidden"
    },
    vectorEffect: "non-scaling-stroke",
    x: -540,
    y: -540,
    rx: 0,
    ry: 0,
    width: 1080,
    height: 1080
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 540 540)",
    id: "32dc56d8-3258-462c-817a-075f758273c9"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.72 0 0 6.72 540 540)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {},
    vectorEffect: "non-scaling-stroke"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 0 -14.94)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,94,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-75.05, -60.85)",
    d: "M 75.7 1.5 L 85 8.4 C 85.3 8.6 85.6 8.700000000000001 85.9 8.6 L 97.10000000000001 5.8 C 97.60000000000001 5.7 98.10000000000001 5.8999999999999995 98.30000000000001 6.3 L 104.30000000000001 16.2 C 104.50000000000001 16.5 104.80000000000001 16.7 105.10000000000001 16.7 L 116.50000000000001 18.4 C 117.00000000000001 18.5 117.40000000000002 18.9 117.50000000000001 19.4 L 119.20000000000002 30.799999999999997 C 119.30000000000001 31.099999999999998 119.40000000000002 31.4 119.70000000000002 31.599999999999998 L 129.60000000000002 37.599999999999994 C 130.00000000000003 37.89999999999999 130.20000000000002 38.39999999999999 130.10000000000002 38.8 L 127.30000000000003 50 C 127.20000000000003 50.3 127.30000000000003 50.7 127.50000000000003 50.9 L 134.40000000000003 60.2 C 134.70000000000005 60.6 134.70000000000005 61.1 134.40000000000003 61.5 L 127.50000000000003 70.8 C 127.30000000000003 71.1 127.20000000000003 71.39999999999999 127.30000000000003 71.7 L 130.10000000000002 82.9 C 130.20000000000002 83.4 130.00000000000003 83.9 129.60000000000002 84.10000000000001 L 119.70000000000002 90.10000000000001 C 119.40000000000002 90.30000000000001 119.20000000000002 90.60000000000001 119.20000000000002 90.9 L 117.50000000000001 102.30000000000001 C 117.40000000000002 102.80000000000001 117.00000000000001 103.20000000000002 116.50000000000001 103.30000000000001 L 105.10000000000001 105.00000000000001 C 104.80000000000001 105.10000000000001 104.50000000000001 105.20000000000002 104.30000000000001 105.50000000000001 L 98.30000000000001 115.40000000000002 C 98.00000000000001 115.80000000000003 97.50000000000001 116.00000000000001 97.10000000000001 115.90000000000002 L 85.9 113.10000000000002 C 85.60000000000001 113.00000000000003 85.2 113.10000000000002 85 113.30000000000003 L 75.7 120.20000000000003 C 75.3 120.50000000000003 74.8 120.50000000000003 74.4 120.20000000000003 L 65.10000000000001 113.30000000000003 C 64.80000000000001 113.10000000000002 64.50000000000001 113.00000000000003 64.2 113.10000000000002 L 53 115.90000000000002 C 52.5 116.00000000000001 52 115.80000000000003 51.8 115.40000000000002 L 45.8 105.50000000000001 C 45.599999999999994 105.20000000000002 45.3 105.00000000000001 45 105.00000000000001 L 33.6 103.30000000000001 C 33.1 103.20000000000002 32.7 102.80000000000001 32.6 102.30000000000001 L 30.900000000000002 90.9 C 30.8 90.60000000000001 30.700000000000003 90.30000000000001 30.400000000000002 90.10000000000001 L 20.5 84.10000000000001 C 20.1 83.80000000000001 19.9 83.30000000000001 20 82.9 L 22.8 71.7 C 22.900000000000002 71.4 22.8 71 22.6 70.8 L 15.700000000000001 61.5 C 15.4 61.1 15.4 60.6 15.700000000000001 60.2 L 22.6 50.900000000000006 C 22.8 50.60000000000001 22.900000000000002 50.300000000000004 22.8 50.00000000000001 L 20 38.80000000000001 C 19.9 38.30000000000001 20.1 37.80000000000001 20.5 37.60000000000001 L 30.4 31.60000000000001 C 30.7 31.40000000000001 30.9 31.10000000000001 30.9 30.800000000000008 L 32.6 19.400000000000006 C 32.7 18.900000000000006 33.1 18.500000000000007 33.6 18.400000000000006 L 45 16.700000000000006 C 45.3 16.600000000000005 45.6 16.500000000000007 45.8 16.200000000000006 L 51.8 6.300000000000006 C 52.099999999999994 5.900000000000006 52.599999999999994 5.700000000000006 53 5.800000000000006 L 64.2 8.600000000000005 C 64.5 8.700000000000005 64.9 8.600000000000005 65.10000000000001 8.400000000000006 L 74.4 1.5000000000000053 C 74.7 1.2 75.3 1.2 75.7 1.5 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 8.85 30.91)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(237,139,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-0.3,43.6 10.4,34.3 24.4,36.1 0.3,-43.6 -24.4,-36.2 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -8.15 30.91)"
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(251,176,64)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    points: "-0.7,43.6 -11.1,34 -25.2,35.6 0.7,-43.6 25.2,-35.6 "
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.05 -14.79)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(234,234,233)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    cx: 0,
    cy: 0,
    r: 44
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.05 -14.74)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(250,250,250)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-75, -61.05)",
    d: "M 75 91 C 58.5 91 45.1 77.5 45.1 61 C 45.1 44.5 58.5 31.1 75 31.1 C 91.5 31.1 104.9 44.5 104.9 61 C 104.9 77.5 91.5 91 75 91 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.05 -14.74)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(18,49,85)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-75, -61.05)",
    d: "M 75 34.1 C 89.9 34.1 101.9 46.2 101.9 61 C 101.9 75.8 89.9 88 75 88 C 60.099999999999994 88 48.1 75.9 48.1 61 C 48.1 46.099999999999994 60.1 34.1 75 34.1 M 75 28.1 C 56.8 28.1 42.1 42.900000000000006 42.1 61 C 42.1 79.1 56.8 94 75 94 C 93.2 94 107.9 79.2 107.9 61.1 C 107.9 43 93.2 28.1 75 28.1 L 75 28.1 z",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -0.1 -14.79)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      fill: "rgb(0,94,184)",
      fillRule: "nonzero",
      opacity: 1
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-74.95, -61)",
    d: "M 83.3 51 L 72.2 62.1 L 66.60000000000001 56.5 L 62.2 61 L 72.2 71 L 87.7 55.4 L 83.3 51 z",
    strokeLinecap: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuality);
export default __webpack_public_path__ + "static/media/quality.17e10100bff2276e41eee6e7a63a8531.svg";
export { ForwardRef as ReactComponent };